import { requestBuilder } from '../../http/RequestBuilder';
import type { PartialBill } from '../types/Bill';

interface BillsApiRemoveTransactionParams {
    membershipId: string;
    billId: string;
    transactionId: string;
}

const useRemoveTransaction = requestBuilder.mutation<
    PartialBill,
    null,
    BillsApiRemoveTransactionParams
>({
    endpoint: ({ membershipId, billId, transactionId }) =>
        `/api/holistic-bills/${membershipId}/bill/${billId}/transaction/${transactionId}`,
    method: 'DELETE',
});

export default useRemoveTransaction;
